import useStyles from 'isomorphic-style-loader/useStyles';
import React, { useEffect, useMemo, useRef, useCallback } from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import { connect, useSelector } from 'react-redux';
import { register } from 'swiper/swiper-element-bundle';
import * as videoStoriesSwiperStyles from './VideoStoriesSwiper.scss';
import * as Styles from './View.scss';
import { dispatchSkyfireMethods } from '../utils';
import VideoStory from './VideoStory';
import { SET_VIDEO_STORY_PLAYERS } from '../actions/VideoStory';
import { getInstance as getHtml5VideoPlayerInstance } from '../player/html5VideoPlayer';
const SLIDE_NEXT_TRANSITION_EVENT = 'slidenexttransitionend';
const SLIDE_PREV_TRANSITION_EVENT = 'slideprevtransitionend';
function VideoStoriesSwiper(props) {
    useStyles(videoStoriesSwiperStyles, Styles);
    // register Swiper custom elements
    // eslint-disable-next-line no-constant-condition
    if (false) {
        register();
    }
    const isOnNavigateEqual = (prev, next) => { var _a, _b; return ((_a = prev[0]) === null || _a === void 0 ? void 0 : _a.currentTemplateIndex) === ((_b = next[0]) === null || _b === void 0 ? void 0 : _b.currentTemplateIndex); };
    const swiperContainerRef = useRef(null);
    const onNavigateToNext = useSelector((state) => state.VideoStoriesMedia.events.onNavigateToNext, isOnNavigateEqual);
    const onNavigateToPrevious = useSelector((state) => state.VideoStoriesMedia.events.onNavigateToPrevious, isOnNavigateEqual);
    const currentTemplateIndex = useSelector((state) => state.VideoStoriesMedia.metadata.currentTemplateIndex);
    const onVideoStoryTemplateQueueRequired = useSelector((state) => state.VideoStoriesMedia.events.onVideoStoryTemplateQueueRequired);
    useEffect(() => {
        var _a;
        if (((_a = props.templateQueue) === null || _a === void 0 ? void 0 : _a.length) < 1) {
            dispatchSkyfireMethods(props.dispatch, props.template, onVideoStoryTemplateQueueRequired);
        }
    }, [props.templateQueue]);
    useEffect(() => {
        var _a;
        const swiperContainer = document.querySelector('swiper-container');
        (_a = swiperContainer === null || swiperContainer === void 0 ? void 0 : swiperContainer.swiper) === null || _a === void 0 ? void 0 : _a.slideTo(currentTemplateIndex, 200);
    }, [currentTemplateIndex]);
    useEffect(() => {
        const swiperContainer = swiperContainerRef.current;
        // const swiperContainer = document.querySelector('swiper-container');
        const handleNextTransition = () => {
            dispatchSkyfireMethods(props.dispatch, props.template, onNavigateToNext);
        };
        const handlePrevTransition = () => {
            dispatchSkyfireMethods(props.dispatch, props.template, onNavigateToPrevious);
        };
        swiperContainer === null || swiperContainer === void 0 ? void 0 : swiperContainer.addEventListener(SLIDE_NEXT_TRANSITION_EVENT, handleNextTransition);
        swiperContainer === null || swiperContainer === void 0 ? void 0 : swiperContainer.addEventListener(SLIDE_PREV_TRANSITION_EVENT, handlePrevTransition);
        return () => {
            swiperContainer === null || swiperContainer === void 0 ? void 0 : swiperContainer.removeEventListener(SLIDE_NEXT_TRANSITION_EVENT, handleNextTransition);
            swiperContainer === null || swiperContainer === void 0 ? void 0 : swiperContainer.removeEventListener(SLIDE_PREV_TRANSITION_EVENT, handlePrevTransition);
        };
    }, [onNavigateToNext, onNavigateToPrevious]);
    const updateVideoStoryPlayer = useCallback((template) => {
        function getVideoStoryPlayer() {
            return getHtml5VideoPlayerInstance();
        }
        return getVideoStoryPlayer();
    }, []);
    const videoStoryPlayers = [];
    const slides = useMemo(() => props.templateQueue.map((template, i) => {
        const player = updateVideoStoryPlayer(template);
        videoStoryPlayers.push(player);
        const videoStory = (React.createElement(VideoStory, { template: template, player: player, key: `VideoStory-${template.playbackURL}` }));
        return (React.createElement(VideoStorySlide, { i: i, template: template, videoStory: videoStory, key: `VideoStorySlide-${template.playbackURL}` }));
    }), [props.templateQueue]);
    useEffect(() => {
        props.dispatch({
            type: SET_VIDEO_STORY_PLAYERS,
            payload: { videoStoryPlayers },
        });
    }, [slides]);
    return (React.createElement("swiper-container", { "slides-per-view": "1", "swiper-button-disabled": "true", "initial-slide": currentTemplateIndex, className: videoStoriesSwiperStyles.videoStoriesSwiper, key: "VideoStorySwiperContainer", ref: swiperContainerRef }, slides));
}
const VideoStorySlide = React.memo((slideProps) => (React.createElement("swiper-slide", { id: `swiper-slide-${slideProps.i}`, key: `VideoStorySwiperSlide-${slideProps.template.playbackURL}` },
    React.createElement("div", { id: `video-stories-overlay-${slideProps.i}` }, slideProps.videoStory))));
VideoStorySlide.displayName = 'VideoStorySlide';
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}
export default React.memo(withStyles(Styles)(connect(null, mapDispatchToProps)(VideoStoriesSwiper)), (prevProps, nextProps) => prevProps.templateQueue.playbackURL === nextProps.templateQueue.playbackURL);
